export class GetLatestPriorAuthorizationItems {
  static readonly type = '[Dashboard] Get latest prior authorization items';
  constructor(public payload: { pharmacyId: number }) {}
}
